 <template>
  <v-layout row wrap>
    <v-card class="pa-2">
      <v-card-title class="headline grey lighten-2" primary-title>
        GL Transaction Detail
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.journal }}</v-subheader>
                <span class="queryValue">{{ glTransDet.journal }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.itemNo }}</v-subheader>
                <span class="queryValue">{{ glTransDet.itemNo }}</span>
              </v-flex>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.glAcctNo }}</v-subheader>
                <span class="queryValue">{{ glTransDet.glAcctNo }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.gstStatRate }}</v-subheader>
                <span class="queryValue">{{ filterGstStatusRate }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.gstAmt }}</v-subheader>
                <span class="queryValue">{{ glTransDet.gstAmt }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.origCurrAmt }}</v-subheader>
                <span class="queryValue">{{ glTransDet.origCurrAmt }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.locAmt }}</v-subheader>
                <span class="queryValue">{{ glTransDet.locAmt }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.transDate }}</v-subheader>
                <span class="queryValue">{{ glTransDet.transDate }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.acctPeriod }}</v-subheader>
                <span class="queryValue">{{ glTransDet.acctPeriod }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.glInterface }}</v-subheader>
                <span class="queryValue">{{ glTransDet.glInterface }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.batchNo }}</v-subheader>
                <span class="queryValue">{{ glTransDet.batchNo }}</span>
              </v-flex>
              <v-flex md12 xs12>
                <v-checkbox color="primary" :label="glTransDetLabel.reversalStat" v-model="glTransDet.reversalStat" readonly></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Document Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-flex xs12>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.docBrn }}</v-subheader>
                            <div class="queryValue" v-for="item in filterDocBranchList" :key="item.label">{{ item.label }}</div>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.docFund }}</v-subheader>
                            <div class="queryValue" v-for="item in filterDocFundList" :key="item.label">{{ item.label }}</div>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.docNo }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.docNo }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.docAcctSfx }}</v-subheader>
                            <div class="queryValue" v-for="item in filterDocSuffixList" :key="item.label">{{ item.label }}</div>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.acctNo }}</v-subheader>
                            <div class="queryValue" v-for="item in filterAccountNoList" :key="item.label">{{ item.label }}</div>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.rbcAcctNo }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.rbcAcctNo }}</span>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Other Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-flex xs12>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.polNo }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.polNo }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.clmNo }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.clmNo }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.comDate }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.comDate }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.expDate }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.expDate }}</span>
                          </v-flex>
                          <v-flex md6 xs12 v-if="displayCRBudget">
                            <v-subheader class="queryLabel">{{ glTransDetLabel.project }}</v-subheader>
                            <span class="queryValue">{{ glTransDet.project }}</span>
                          </v-flex>
                          <v-flex md6 xs12 v-if="displayCRBudget">
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glDept }}</v-subheader>
                            <div class="queryValue" v-for="item in filterGLDepartmentList" :key="item.label">{{ item.label }}</div>
                          </v-flex>
                          <v-flex md12 xs12>
                            <v-checkbox color="primary" :label="glTransDetLabel.holdGLUpd" v-model="glTransDet.holdGLUpd" readonly></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel :disabled="chkGlSys()">
              <v-expansion-panel-header>
                <div><v-icon>mdi-plus</v-icon><span class="headerTitle">GL Analysis Codes</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-flex xs12>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc1 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc1) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc2 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc2) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc3 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc3) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc4 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc4) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc5 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc5) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc6 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc6) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc7 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc7) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc8 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc8) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc9 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc9) }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ glTransDetLabel.glAc10 }}</v-subheader>
                            <span class="queryValue">{{ filterGlAcCodeList(glTransDet.glAc10) }}</span>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md12 xs12></v-flex>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.createdBy }}</v-subheader>
                <span class="queryValue">{{ glTransDet.createdBy }}</span>
              </v-flex>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">{{ glTransDetLabel.modifiedBy }}</v-subheader>
                <span class="queryValue">{{ glTransDet.modifiedBy }}</span>
              </v-flex>
              <v-flex md12 xs12></v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'

export default {
  data() {
    return {
      showGLDetail: false,
      glTransDetLabel: {
        journal: 'Journal',
        itemNo: 'Item No.',
        glAcctNo: 'GL Account No.',
        gstStatRate: 'GST Status, Rate',
        gstAmt: 'GST Amount',
        origCurrAmt: 'Original Currency Amount',
        locAmt: 'Local Amount',
        transDate: 'Transaction Date',
        acctPeriod: 'Accounting Period',
        glInterface: 'GL Interface',
        batchNo: 'Batch No.',
        reversalStat: 'Reversal Status',
        createdBy: 'Created By',
        modifiedBy: 'Modified By',
        docBrn: 'Branch',
        docFund: 'Fund',
        docNo: 'Document No.',
        docAcctSfx: 'Account No. Suffix',
        acctNo: 'Account No.',
        rbcAcctNo: 'RBC Account No.',
        polNo: 'Policy No.',
        clmNo: 'Claim No',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        holdGLUpd: 'Hold GL Update',
        glAc1: 'Code 1',
        glAc2: 'Code 2',
        glAc3: 'Code 3',
        glAc4: 'Code 4',
        glAc5: 'Code 5',
        glAc6: 'Code 6',
        glAc7: 'Code 7',
        glAc8: 'Code 8',
        glAc9: 'Code 9',
        glAc10: 'Code 10',
        tranDate: 'Transaction Date',
        polOrClm: 'Policy or Claim',
        project: 'Project Code',
        glDept: 'GL Department'
      },
      allbranches: [],
      gstStatuses: [],
      funds: [],
      acctnosuffixes: [],
      accountnos: [],
      glanalysiscodes: [],
      glDepartments: []
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.loadDetail()
      }
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      this.fetchAccount()
      this.fetchBranch()
      this.fetchGstStatus()
      this.fetchFund()
      this.fetchAcctNoSfx()
      this.fetchGlAnalysisCode()
      this.fetchGlDepartment()
      this.fetchGLData(this.objData.glJrnl, this.objData.glItemNo)
    },
    closeDialog() {
      this.$emit('close')
    },
    chkRbcTran() {
      if (this.accounts.rbcTran === 'Yes') {
        return false
      } else {
        return true
      }
    },
    chkGlSys() {
      if (this.glTransDet.glSys === 2) {
        return false
      } else {
        return true
      }
    },
    filterGlAcCodeList(value) {
      const glAcCode = this.glanalysiscodes.find(list =>
        list.value === value
      )
      return glAcCode ? glAcCode.label : ''
    }
  },
  computed: {
    displayCRBudget() {
      return this.glTransDet.glApplnInt === 6001 && this.glTransDet.glTranType === 'Z'
    },
    filterDocBranchList() {
      return this.allbranches.filter((list) => {
        return list.value === this.glTransDet.docBrn
      })
    },
    filterGstStatusRate() {
      let gststat = this.gstStatuses
        .filter(gst => gst.value === this.objData.gstStat)
        .map(gst => gst.label)
      return gststat + ', ' + this.glTransDet.gstRate
    },
    filterDocFundList() {
      return this.funds.filter((list) => {
        return list.value === this.glTransDet.docFund
      })
    },
    filterDocSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.glTransDet.docAcctSfx
      })
    },
    filterAccountNoList() {
      return this.accountnos.filter((list) => {
        return list.value === this.glTransDet.acctNo
      })
    },
    filterGLDepartmentList() {
      return this.glDepartments.filter((list) => {
        return list.value === this.glTransDet.glDept
      })
    }
  },
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    objData: {
      type: Object,
      default: null
    }
  },
  mixins: [TableConst.default, accountsAjaxCalls, accountsFilters, accountsViewMixin]
}
</script>
